export class CallRecordings {
  call_recording_urls?: string[];
  voicemail_recording_urls?: string[];

  constructor(payload?: ICallRecordings) {
    this.call_recording_urls = payload?.call_recording_urls;
    this.voicemail_recording_urls = payload?.voicemail_recording_urls;
  }
}

export interface ICallRecordings {
  voicemail_recording_urls?: string[];
  call_recording_urls?: string[];
}
